<div page-content [fullWidth]="true">
  <div actions class="uk-section-primary uk-preserve-color">
    <sidebar-mobile-toggle class="uk-hidden@m uk-display-block uk-padding-small"></sidebar-mobile-toggle>
  </div>
  <div inner>
    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent>
      <div class="uk-container">
        <div class="uk-flex uk-flex-between uk-flex-middle uk-visible@m">
          <!--          <h4>Open Software</h4>-->
          <div class="uk-flex uk-flex-middle uk-margin-bottom">
            <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"
              class="flag-image" width="42" height="42" alt="rounded flag image">
            <div class="uk-margin-small-left">
              <h4 class="uk-margin-remove-bottom">{{ countryName }} - Open Software for {{ year }}</h4>
            </div>
          </div>
          <div class="uk-flex uk-flex-center" (click)="exportToPDF([exportContent, exportContent1], 'Open Data')"
            style="cursor: pointer">
            <div class="uk-flex uk-flex-middle uk-text-primary"
              style="background-color: #DAEEF3; border-radius: 30px; padding: 5px 7px">
              <span class=""
                style="background-color: #fff; border-radius: 50px; border: 1px solid #008691; padding: 4px 10px">
                Export report
              </span>
              @if (exportActive) {
                <span class="uk-margin-small-left"
                data-uk-spinner="ratio: 0.7"></span>
              } @else {
                <span class="material-symbols-outlined filled uk-margin-small-left uk-text-primary">download</span>
              }
            </div>
          </div>
        </div>
        <div class="uk-hidden@m">
          <!--          <h4>Open Software</h4>-->
          <div class="uk-flex uk-flex-middle uk-margin-bottom">
            <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"
              class="flag-image" width="42" height="42" alt="rounded flag image">
            <div class="uk-margin-small-left">
              <h4 class="uk-margin-remove-bottom">{{ countryName }} - Open Software for {{ year }}</h4>
            </div>
          </div>
          <div class="uk-flex uk-flex-right" (click)="exportToPDF([exportContent, exportContent1], 'Open Data')"
            style="cursor: pointer">
            <div class="uk-flex uk-flex-middle uk-text-primary"
              style="background-color: #DAEEF3; border-radius: 30px; padding: 5px 7px">
              <span class=""
                style="background-color: #fff; border-radius: 50px; border: 1px solid #008691; padding: 4px 10px">
                Export report
              </span>
              @if (exportActive) {
                <span class="uk-margin-small-left"
                data-uk-spinner="ratio: 0.7"></span>
              } @else {
                <span class="material-symbols-outlined filled uk-margin-small-left uk-text-primary">download</span>
              }
            </div>
          </div>
        </div>
        <!--        <div class="uk-flex uk-flex-middle uk-margin-bottom">-->
        <!--          <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"-->
        <!--            class="flag-image" width="42" height="42" alt="rounded flag image">-->
        <!--          <div class="uk-margin-small-left">-->
        <!--            <h3 class="uk-margin-remove-bottom">{{ countryName }}</h3>-->
      <!--          </div>-->
    <!--        </div>-->

    <!--        <div class="uk-flex uk-flex-between uk-flex-middle">-->
    <!--          <h4>Open Software</h4>-->
  <!--        </div>-->

  <div class="section-hidden-notice-band">
    <app-section-hidden-notice sectionName="Open Software"></app-section-hidden-notice>
  </div>

  <p class="uk-margin-medium-bottom">Open software is a vital component of Open Science, enabling key stakeholders to access, modify, and share
    tools that drive innovation and collaboration in research.
    It fosters transparency, reproducibility, and interoperability across scientific disciplines.
    This page provides an overview of open software initiatives in Europe, including data on policies, financial
  investments, and strategies from the Survey on National Contributions to EOSC and Open Science</p>

  <div class="uk-flex uk-flex-between uk-flex-middle">
    <h5>General Overview of Open Software in {{ countryName }} for {{ year }}</h5>
  </div>

  <div class="uk-grid-small" data-uk-grid>
    @if (hasAnyLeftCardVisible()) {
      <div class="uk-width-1-1 uk-width-3-5@m uk-animation-fade">
        <div class="uk-card uk-card-default uk-card-body">
          <div class="uk-child-width-1-1 uk-child-width-1-2@s uk-grid-small uk-grid-match uk-flex uk-flex-center" data-uk-grid data-uk-height-match="target: > * .uk-card">
            <!-- Card 1 -->
            <!-- <div *ngIf="OpenTrainingPercentage[1] !== null" class="uk-animation-scale-up">
            <div class="uk-card card-simple uk-card-small uk-card-body">
              <p>Percentage of <span class="uk-text-bold">Open Repositories in {{ countryName }}</span></p>
              <div class="number big uk-margin-medium-top">
                <span class="uk-text-bold">{{ OpenTrainingPercentage[1] }}%</span>
              </div>
              <div *ngIf="OpenTrainingPercentageDiff !== null" class="uk-flex uk-flex-between uk-flex-bottom uk-width-1-1">
                <div class="uk-flex uk-flex-middle">
                  <span class="material-symbols-outlined" [ngClass]="OpenTrainingPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                    {{ OpenRepositoriesPercentageDiff >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                  </span>
                  <span [ngClass]="OpenTrainingPercentageDiff >= 0 ? 'percentage-up-color' : 'percentage-down-color'">
                    {{ Math.abs(OpenTrainingPercentageDiff) }}%
                  </span>&nbsp; vs last year
                </div>
                <div>
                  <img [ngSrc]="'../assets/images/explore/' + (OpenTrainingPercentageDiff >= 0 ? 'trend_green' : 'trend_red') + '.svg'"
                  alt="trend image" height="50" width="99">
                </div>
              </div>
            </div>
          </div> -->
          <!--Card 2-->
          <app-card-config indicatorId="62" colorClass="eosc-sb visualisation-card">
          @if (rfoSoftwarePercentage[1] !== null && rfoSoftwarePercentage[1] !== undefined) {
            <app-info-card
              [titleHtml]="`Percentage of <span class='uk-text-bold'>RFO's Policy on Open Software</span>`"
              [value]="rfoSoftwarePercentage[1]"
              [unit]="'%'"
              [diff]="rfoSoftwarePercentageDiff"
              colorClass="eosc-sb visualisation-card">
            </app-info-card>
          }
          </app-card-config>
          <!-- Card 3 -->
          <app-card-config indicatorId="63" colorClass="eosc-sb visualisation-card">
          @if (softwareFinancialInvestment[1]) {
            <app-info-card
              [titleHtml]="'Total <span class=\'uk-text-bold\'>financial investment in Open Software</span>'"
              [value]="softwareFinancialInvestment[1]"
              [unit]="'mil Euro'"
              [diff]="softwareFinancialInvestmentPercentageDiff"
              colorClass="eosc-sb visualisation-card">
            </app-info-card>
          }
          </app-card-config>
          <!--Card 4-->
          <app-card-config indicatorId="64" colorClass="eosc-sb visualisation-card">
          @if (rpoSoftwarePercentage[1] !== null && rpoSoftwarePercentage[1] !== undefined) {
            <app-info-card
              [titleHtml]="`Percentage of <span class='uk-text-bold'>RPO's Policy on Open Software</span>`"
              [value]="rpoSoftwarePercentage[1]"
              [unit]="'%'"
              [diff]="rpoSoftwarePercentageDiff"
              colorClass="eosc-sb visualisation-card">
            </app-info-card>
          }
          </app-card-config>
        </div>
      </div>
    </div>
  }

  <!-- Right Card-->
  <app-card-config indicatorId="65" class="uk-width-1-1 uk-width-2-5@m uk-animation-fade">
  <div>
    <div class="uk-card uk-card-default uk-card-body eosc-sb visualisation-card">
      <div class="uk-margin-top">
        <h5 class="uk-flex uk-flex-between uk-margin-remove">
          National Open Software Policy
                  <span class="material-symbols-outlined" [ngClass]="{
                  'up-arrow-color': hasNationalPolicy === 'Yes',
                  'down-arrow-color': hasNationalPolicy === 'No',
                  'unanswered-color': hasNationalPolicy === null
                }">
            {{
            hasNationalPolicy === 'Yes' ? 'check' :
            hasNationalPolicy === 'No' ? 'close' :
            'question_mark'
            }}
          </span>
        </h5>
        @if (policyMandatory === 'Yes') {
          <p class="uk-text-primary uk-text-bolder uk-margin-remove-top">
          Mandatory policy</p>
        }
        @if (nationalPolicyClarification) {
          <read-more-text [maxHeight]="68"
            [text]="nationalPolicyClarification">
          </read-more-text>
        }
      </div>

      <div class="uk-margin-top">
        <h5 class="uk-flex uk-flex-between">
          Financial Strategy on Open Software
                  <span class="material-symbols-outlined" [ngClass]="{
                  'up-arrow-color': hasFinancialStrategy === 'Yes',
                  'down-arrow-color': hasFinancialStrategy === 'No',
                  'unanswered-color': hasFinancialStrategy === null
                }">
            {{
            hasFinancialStrategy === 'Yes' ? 'check' :
            hasFinancialStrategy === 'No' ? 'close' :
            'question_mark'
            }}
          </span>
        </h5>
        @if (financialStrategyClarification) {
          <read-more-text [maxHeight]="68"
            [text]="financialStrategyClarification">
          </read-more-text>
        }
      </div>

      <div class="uk-margin-top">
        <h5 class="uk-flex uk-flex-between">
          Monitoring on Open Software
                  <span class="material-symbols-outlined" [ngClass]="{
                  'up-arrow-color': hasMonitoring === 'Yes',
                  'down-arrow-color': hasMonitoring === 'No',
                  'unanswered-color': hasMonitoring === null
                }">
            {{
            hasMonitoring === 'Yes' ? 'check' :
            hasMonitoring === 'No' ? 'close' :
            'question_mark'
            }}
          </span>
        </h5>
        @if (monitoringClarification) {
          <read-more-text [maxHeight]="68" [text]="monitoringClarification">
          </read-more-text>
        }
      </div>
    </div>
  </div>
  </app-card-config>
</div>
<div class="uk-width-1-1 uk-margin-top uk-flex uk-flex-center">

  <div>
    <p><span class="uk-text-bold">Data source:</span>
    Survey on National Contributions to EOSC and Open Science {{year}} -
    showing data for {{ year }}, except financial contributions, which reflect the previous year ({{+year-1}});
    OpenAIRE Graph data for {{ year }} (updated on {{ lastUpdateDate }}).
  </p>
</div>
</div>
</div>
</div>


<!-- <pre>{{ surveyAnswers[1] | json }}</pre> -->
<div #exportContent1>
  @if (hasSurveySoftwareData()) {
    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small">
      <div class="uk-container">
        <app-card-config indicatorId="66">
        <div class="uk-animation-fade">
          <div class="uk-card uk-card-body uk-card-default uk-width-1-1 noads visualisation-card">
            <h6 class="uk-margin-bottom">Learn more about Open Software Landscape in {{ countryName }}</h6>
            <div class="uk-text-meta">This information has been compiled by the National Open Access Desks on {{ countrySurveyAnswerLastUpdate | date: 'yyyy-MM-dd'}}</div>
            <div class="uk-margin-medium-top">
              <read-more [maxHeight]="300">
                <div id="software_repositories">
                  <div class="uk-text-secondary">Software repositories</div>
                  @if (countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question19']?.['Question19-1']) {
                    <div
                      [innerHTML]="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question19']['Question19-1']"
                    class="uk-margin-medium-top"></div>
                  } @else {
                    <p>N/A</p>
                  }
                </div>
              </read-more>
            </div>
          </div>
        </div>
        </app-card-config>
      </div>
    </div>
  }

</div>
</div>
</div>
